namespace RioERP.Web.Enums {
    export enum SerialkeyStatus {
        Failed = 1,
        Created = 2,
        Activated = 3
    }
    Serenity.Decorators.registerEnumType(SerialkeyStatus, 'RioERP.Web.Enums.SerialkeyStatus');
}
